module.exports = "//static.hsappstatic.net/salesImages/static-1.403/meetings/pql/booked-calendar.svg"